import styled from '@emotion/styled';

export const ProductTitle = styled.h1`
  font-size: 2.25rem;
  margin-bottom: 15px;
  word-wrap: break-word;
  font-family: 'Helvetica', 'Helvetica', sans-serif;
  font-weight: 400;
  margin: 0 0 0.5rem;
  line-height: 1.4;
`;

export const ProductDescription = styled.div`
  font-family: 'Helvetica', 'Helvetica', sans-serif;
  font-weight: 300;
  display: flex;
  flex-direction: row;
  @media (max-width: 750px) {
    flex-direction: column;
  }
  .coffee-description {
    padding: 24px;
    font-family: Inter;
    position: absolute;
    top: 0;
    margin-left: 348px;
    @media (max-width: 750px) {
      margin-top: 0;
      position: relative;
      margin-left: initial;
    }
  }
  .coffee-data {
    width: 350px;
    margin-top: -40px;
    display: block;
    padding: 24px;
    background-color: antiquewhite;
    border: 4px solid black;
    border-top: none;
    p {
      font-size: 12px !important;
      font-family: monospace;
      margin-bottom: 0;
    }
    @media (max-width: 650px) {
      border-top: 4px solid black;
      margin-top: 0;
      width: 100%;
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 40px;
  margin-top: 40px;
  @media (max-width: 750px) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 24px;
    margin-bottom: 24px;
    gap: 0;
    img {
      margin-top: 24px;
    }
  }
`;
